// eslint-disable-next-line no-undef
export const APP_COLOR = __APP_COLOR__;
// eslint-disable-next-line no-undef
export const APP_VERSION = __APP_VERSION__;
// eslint-disable-next-line no-undef
export const APP_BUILT_DATE = __APP_BUILT_DATE__;